module.exports = __webpack_public_path__ + "static/media/spacey-left.bc7b465c.png";